<template>
  <div class="sale-wrapper bj">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
      v-loading="loading"
        :data="tableData"
        height="100%"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          prop="business_name"
          align="center"
          label="集配中心"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="supplier.title"
          align="center"
          label="供应商"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="supplier.mobile"
          align="center"
          label="供应商电话"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="supplier_state_text"
          align="center"
          label="供应商状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="员工姓名"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="mobile"
          align="center"
          label="员工电话"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="staff_type_text"
          align="center"
          label="员工类型"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="staff_state_text"
          align="center"
          label="员工状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="create_time"
          align="center"
          label="添加时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          align="center"
          label="备注"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="menu_list"
          align="center"
          label="权限"
          show-overflow-tooltip
        >
        <template slot-scope="scope">
             <div>{{ scope.row.menu_list.join(',') }}</div>
            </template>
        </el-table-column>



        <el-table-column
            label="操作"
            fixed="right"
            align="center"
            min-width="130"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="changeRecordclcik(scope.row)"
                >查看日志</el-button
              >
            </template>
          </el-table-column>
      </el-table>

     
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <changeRecord ref="changeRecordref"></changeRecord>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";

import changeRecord from "./modules/changeRecord.vue";

export default {
  name: "supplier",
  components: {
    Filtersearch,

    changeRecord,
  },
  data() {
    return {
      currentPage: 0,
      total: 0,
      loading: false,
      disabledExport: false, // 导出按钮
      tableData: [],
      from: {
        page: 1,
        pageSize: 50,
        supplier_id: "", //	T文本	是	供应商
        staff_name: "", //	T文本	是	员工姓名
        staff_mobile: "", //	T文本	是	员工电话
        staff_state: "", //	T文本	是	员工状态
        logistic_business_id: "", //	T文本	是	集配中心
        supplier_mobile: "", //	T文本	是	供应商名称
        supplier_state: "", //	T文本	是	供应商状态
        staff_type: "", //	T文本	是	员工类型
      },
      from1: "",
      Selectionlist: [],
      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选择集配中心",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "business",
        },
        {
          type: "select",
          name: "供应商",
           clearable: true,
          filterable: true,
          model: "supplier_id",
          placeholder: "请选择供应商",
          label: "title",
          value: "id",
          selectoption: [],
          selectoptionname: "supplier",
        },
      
        {
          type: "input",
          name: "供货商电话",
          clearable: true,
          model: "supplier_mobile",
          placeholder: "请输入供货商电话",
        },
        {
          type: "input",
          name: "员工姓名",
          clearable: true,
          model: "staff_name",
          placeholder: "请输入员工姓名",
        },
        {
          type: "input",
          name: "员工电话",
          clearable: true,
          model: "staff_mobile",
          placeholder: "请输入员工电话",
        },
        {
          type: "select",
          name: "员工类型",
           clearable: true,
          filterable: true,
          model: "staff_type",
          placeholder: "请选择员工类型",
          label: "label",
          value: "value",
          selectoption: [],
          selectoptionname: "staff_type",
        },
        {
          type: "select",
          name: "员工状态",
           clearable: true,
          filterable: true,
          model: "staff_state",
          placeholder: "请选择员工状态",
          label: "label",
          value: "value",
          selectoption: [],
          selectoptionname: "staff_state",
        },
        {
          type: "select",
          name: "供应商状态",
           clearable: true,
          filterable: true,
          model: "supplier_state",
          placeholder: "请选择供应商状态",
          label: "label",
          value: "value",
          selectoption: [],
          selectoptionname: "supplier_state",
        },
        
      ],
     
    };
  },
  created() {
    this.from1 = JSON.parse(JSON.stringify(this.from));
    this.hqlist();
    this.getsearch();
  },
  watch: {},
  methods: {
    changeRecordclcik(e) {
        this.$refs.changeRecordref.onInitData(e);
      // stafflog
    },

    getsearch() {
      this.$api.payment.searchData().then((res) => {
        this.Filtersearchlist.forEach((el) => {
          if (el.type == "select" && el.selectoptionname) {
            let obj = { [el.value]: "", [el.label]: "全部" };
            el.selectoption = [obj, ...res.data[el.selectoptionname]];
          }
        });
      });
    },
    Refresh() {
      Object.assign(this.$data.from, this.$options.data().from);
      this.from1 = JSON.parse(JSON.stringify(this.from));
      this.hqlist();
    },

    // tablechange(e) {
    //   this.tablecolumn = e;
    // },
    tablechange() {
      this.hqlist();
    },
    Selection(e) {
      this.Selectionlist = e;
      console.log(e, "选中了那些东西");
    },
    search(e) {
      this.from.page = 1;
      this.currentPage = 1;
      this.from = e;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.payment.stafflist(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss">
.sale-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
